import { render, staticRenderFns } from "./CertificadorBHPPantalla.vue?vue&type=template&id=4968f59e&"
import script from "./CertificadorBHPPantalla.vue?vue&type=script&lang=ts&"
export * from "./CertificadorBHPPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4968f59e', component.options)
    } else {
      api.reload('4968f59e', component.options)
    }
    module.hot.accept("./CertificadorBHPPantalla.vue?vue&type=template&id=4968f59e&", function () {
      api.rerender('4968f59e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CertificadorBHP/CertificadorBHPPantalla.vue"
export default component.exports